import { useAppSelector } from '../../app/hooks';

const Spinner = () => {
  const pendingActions = useAppSelector((state) => state.loading.pendingActions);
  return (
    <div className={`spinner-grow spinner-grow-sm text-primary ${pendingActions > 0 ? '' : 'd-none'}`} role="status" />
  );
};

export default Spinner;
